export default __webpack_public_path__ + "static/media/rocket1.9fd5b039.gif";